import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-message-card',
  templateUrl: './message-card.component.html',
  styleUrls: ['./message-card.component.scss'],
  imports: [MatIconModule],
  standalone: true,
})
export class MessageCardComponent {
  messageType = input<'warning' | 'info' | 'success' | 'error'>('warning');
}
